import Vue from 'vue';
import { HotelQnaForm } from '@entities/qnaForm';

export class AbstractQnaPage extends Backbone.Epoxy.View {
  initDOMEvents() {
    $('.question__title').on('click', function () {
      const questionElem = $(this).closest('.question');
      questionElem.toggleClass('active');

      if (questionElem.hasClass('active')) {
        questionElem.find('.question__text').slideDown(300);
      } else {
        questionElem.find('.question__text').slideUp(300);
      }
    });
  }
  initialize() {
    this.initDOMEvents();
    new Vue({
      name: 'HotelQnaForm',
      render: (h) =>
        h(HotelQnaForm, {
          props: {
            hotelId: window.appConfig?.hotelInfo?.id,
          },
        }),
    }).$mount('.hotel-qna-form');
  }
}
